// extracted by mini-css-extract-plugin
export var contentBody = "_91-9";
export var headerImage = "_91-2";
export var imageButton = "_91-7";
export var imageButtonIcon = "_91-8";
export var imageHeader = "_91-4";
export var imageHeaderText = "_91-5";
export var imageOverlay = "_91-3";
export var imageTitle = "_91-6";
export var imageWrapper = "_91-1";
export var taskList = "_91-a";
export var widget = "_91-0";